import tw from 'tailwind-styled-components'

export const ConfigsContainer = tw.div`
px-12
py-[33px]
`
export const ConfigsWrapper = tw.div`
bg-white
rounded-lg
boxShadow
min-h-[50vh]
`
export const Nav = tw.nav`
flex 
gap-12 
border-b 
border-borderLine
px-8
pt-8
`
export const navLinkStyled = `
pb-[13px]
text-lg
cursor-pointer
ease-in-out
hover:brightness-90
`

export const styledNav = `
border-b-yellow
border-b-4
text-blueTheme
font-bold
`

export const notStyledNav = `
text-darkGray
`